module.exports = __webpack_public_path__ + "static/media/semiconductors_2_desktop.6cd8ca84.jpg";